import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'services/i18n/i18n';
import App from './App';
import * as serviceWorker from 'serviceWorker';
import './index.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
